export const toId = (label) => label.toString().toLowerCase().replace(" ", "-");